
<article class="shopReviewContent">
  <div class="shopReviewContent__container">
    <div class="shopRecommended__titleContainer">
      <h2 class="shopRecommended__title">{{ shopName }}の口コミ({{ pager.total }})</h2>
    </div>
    <h3 class="shopReviewContent__heading">口コミデータ</h3>
    <div class="shopReviews">
      <shop-review-score :shop-reviews="allShopReviews"></shop-review-score>
      <template v-if="shopReviews.length > 0">
        <div class="shopReviews__pagination-count">{{ pager.offset + 1 }}〜{{ pager.offset + pager.count }}件を表示 / 全{{ pager.total }}件</div>
        <shop-review :shop-review=shopReview v-for="shopReview in shopReviews" :key="shopReview.id"></shop-review>
        <front-pagination :pager="pager" :form="form" />
      </template>
    </div>
  </div>
</article>
